var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-cymasuite",class:{
    'hover:bg-opacity-90': !_vm.disabled,
  },attrs:{"type":"button","disabled":_vm.disabled},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }